import { render, staticRenderFns } from "./FolderAddingRules.vue?vue&type=template&id=071baed5&"
import script from "./FolderAddingRules.vue?vue&type=script&lang=ts&"
export * from "./FolderAddingRules.vue?vue&type=script&lang=ts&"
import style0 from "./FolderAddingRules.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports